import { getSfxPlayer } from "../systems/sfx-generator"
import { AUDIO } from "./keys"

/** Ensure audio contexts are running (iOS may suspend them between interactions) */
function ensureAudioRunning(scene: Phaser.Scene): void {
  // Resume Phaser's WebAudio context
  const soundManager = scene.sound as Phaser.Sound.BaseSoundManager & {
    context?: AudioContext
  }
  const phaserCtx = soundManager.context
  if (phaserCtx && phaserCtx.state !== "running") {
    phaserCtx.resume()
  }
}

/** Play a UI click/select sound. */
export function playClick(scene: Phaser.Scene): void {
  ensureAudioRunning(scene)
  getSfxPlayer(scene)?.play(AUDIO.SFX_UI_PRESS, 0.9)
}

/** Play a UI hover sound. */
export function playHover(scene: Phaser.Scene): void {
  ensureAudioRunning(scene)
  getSfxPlayer(scene)?.play(AUDIO.SFX_UI_BEEP, 0.65)
}

/** Play a purchase/confirm sound. */
export function playConfirm(scene: Phaser.Scene): void {
  ensureAudioRunning(scene)
  getSfxPlayer(scene)?.play(AUDIO.SFX_UI_PRESS, 1.05)
}

/** Play a navigation/advance sound. */
export function playNav(scene: Phaser.Scene): void {
  ensureAudioRunning(scene)
  getSfxPlayer(scene)?.play(AUDIO.SFX_UI_NAVIGATE, 0.75)
}
